import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Product } from '../../../models/product.model';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProductService } from '../../../services/product.service';
import { SharedStateService } from '../../../services/shared-state.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-select-product-to-order',
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    TableModule,
    ButtonModule,
    PaginatorModule
  ],
  templateUrl: './select-product-to-order.component.html'
})

export class SelectProductToOrderComponent implements AfterViewInit {
  @ViewChild('searchInput') searchInput!: ElementRef;

  searchTerm: string = '';
  loading: boolean = true;

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  first: number = 0;
  rows: number = 5;
  totalRecords: number = 0;
  currentPage: number = 1;

  constructor(private productService: ProductService, private sharedState: SharedStateService){

    this.searchSubscription = this.searchSubject.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(term => {
        this.searchTerm = term;
        this.getData();
      });
  }

  @Output() fechar = new EventEmitter<void>();

  products: Product[ ] = [];

  ngAfterViewInit(): void {
    setTimeout(() => this.searchInput?.nativeElement?.focus(), 200);
  }

  ngOnInit(): void {
    this.getData();
  }

  getData(){
    this.productService.getAll(this.searchTerm, true, false, false, this.currentPage).subscribe({next: (data) => {
      this.products = data.data;
      this.totalRecords = data.pagination.totalRecords;
      this.loading = false;
    }, error: (error) => {
      console.log(error)
    }})
  }

  onSearchChange(){
    this.searchSubject.next(this.searchTerm);
  }

  

  onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  select(product: Product) {
    this.sharedState.setSelectedItem(product);
    console.log('q')
    this.fechar.emit();
  }

  cancelar() {
    this.fechar.emit();
  }

}